import React from 'react';

/**
 * Sits under a writer message that has no reply yet.
 * Still writing, or one click to try the same message again.
 */
export default function ReplyFollow({ gap, onRetry }) {
  if (!gap) return null;
  if (gap.kind === 'writing') {
    return (
      <p className="message-list__reply-follow" role="status">
        {gap.message}
      </p>
    );
  }
  return (
    <p className="message-list__reply-follow" role="status">
      {gap.message}{' '}
      <button type="button" className="message-list__reply-retry" onClick={onRetry}>
        Try again
      </button>
    </p>
  );
}
